import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="promoters--events--registrables"
export default class extends Controller {
  checkPrivateEvent(event) {
    let checked_event_ids = [];
    let private_event_ids = [];
    let use_modal_flg = false;
    let hiddens = document.querySelectorAll('input[name="private_events[]"]');
    let checkboxes = document.querySelectorAll('input[name="event_group[event_ids][]"]');

    hiddens.forEach((hidden) => {
      private_event_ids.push(hidden.value);
    });
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        checked_event_ids.push(checkbox.value);
        if (private_event_ids.includes(checkbox.value)) {
          use_modal_flg = true;
        }
      }
    });
    if (use_modal_flg) {
      this.modalShow();
      event.preventDefault();
      return;
    }
    if (checked_event_ids.length === 0) {
      event.preventDefault();
      return;
    }
  }

  // modal_controller.jsのshowを呼び出す
  modalShow() {
    const modalController = this.application.getControllerForElementAndIdentifier(
      document.getElementById("dialog"),
      "modal",
    );
    modalController.show();
  }

  submit() {
    const form = document.getElementById("add_events_form");
    form.requestSubmit();
  }
}
